import AudioComponent from './AudioComponent'
export * from './AudioComponent'
export * from './AudioPlayer'
export * from './Greeting'
export default AudioComponent
